import { z } from "zod";
import {
  siretSchema,
  phoneSchema,
  emailSchema,
  postalCodeSchema,
  nameSchema,
  addressSchema,
  requiredStringSchema,
} from "@/shared/schemas/commonValidationSchemas";

// ----- SCHEMA ----- //
export const supplierSchema = z.object({
  name: requiredStringSchema(100, "La dénomination"),
  siret: siretSchema,
  address: addressSchema(100),
  zip_code: postalCodeSchema,
  city: nameSchema(50, "La ville"),
  phone_number: phoneSchema,
  email: emailSchema,
  comment: z.string().max(250, "Les commentaires ne doivent pas dépasser 250 caract\u00e8res.").optional(),
});

export type SupplierFormData = z.infer<typeof supplierSchema>;
